import React, {useContext, useEffect, useRef, useState} from "react";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import {AdUpdate, AdvertisementZeus, Asset, InputAsset, LogRecord, ResAsset} from "./AdvertisementModelZeus";
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../../atom/Apollo_ApiRequest3";
import {get_zeus_ads} from "../../../atom/Apollo_links";
import AdvertisementFormZeus, {OptionAdgroup} from "./AdvertisementFormZeus";
import {ApolloRightDrawerContext} from "../../../molecule/Apollo_RightDrawer";
import {
  ApolloEventRecord,
  createLogDate,
  createUserLogItemListByOption,
  createUserLogItemListFromString,
  ItemList, LogData, createUserLogItemListFromArrayAddSB
} from "../../../atom/Apollo_EventRecord";
import {ApolloContext} from "../../../atom/Apollo_Context";
import moment from "moment";
import {getSubjectStrCheckErrorMsg, getTextStrCheckErrorMsg, getImageSizeType} from "../../../common/Apollo_CommonUtil";
import {ZEUS_DELIVERY_TYPE, options_state_edit, ZEUS_PMP_TYPE} from "../../../atom/Apollo_styles";
import { AdTitle, AdDescription, AdImage, AdVideo, AdTag, ZeusAd, AdGroupRow } from "../../ADGROUP/zeus/AdGroupModelZeus";

type AdvertisementData = {
  platformAccountId: number,
  advertisementId: number,
  listReloadFunc? : any;
}

// 画面名：広告編集（Zeus）- エキスパンド表示
const AdvertisementEditZeus = ({platformAccountId, advertisementId, listReloadFunc}: AdvertisementData) => {
  const {state} = useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const advertisementData = useRef<AdvertisementZeus | null>(null);
  const beforeEditRecord = useRef<LogRecord | null>(null);
  // 編集用
  const [deliveryType, setDeliveryType] = useState(ZEUS_DELIVERY_TYPE.PERFORMANCE);
  const [pmpType, setPmpType] = useState<number | null>(null);
  const [placementSettingId, setPlacementSettingId] = useState(0);

  const [titles, setTitles] = useState<AdTitle[]>([]);
  const [titleCount, setTitleCount] = useState(0);
  const [isAddedTitle, setIsAddedTitle] = useState(false);

  const [descriptions, setDescriptions] = useState<AdDescription[]>([]);
  const [descriptionCount, setDescriptionCount] = useState(0);
  const [isAddedDescription, setIsAddedDescription] = useState(false);

  const [images, setImages] = useState<AdImage[]>([]);
  const [imageCount, setImageCount] = useState(0);
  const [isAddedImage, setIsAddedImage] = useState(false);

  const [tags, setTags] = useState<AdTag[]>([]);

  const [isAddedTag, setIsAddedTag] = useState(false);
  
  const [selectedFileOrigins, setSelectedFileOrigins] = useState<string[]>([]);
  const [advertisement, setAdvertisement] = useState<AdvertisementZeus>({
    id: advertisementId,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: "",
    adAccountId: 0,
    adCampaignId: 0,
    adGroupId: 0,
    name: "",
    adType: 1,
    status: 2,
    link: "",
    customUrl: "",
    sponsor: "",
    cta: 1,
    sponsorDomain: "",
    titles: [],
    descriptions: [],
    images: [],
    videos: [],
    apps: [],
    mails: [],
    tags: [],
    adAccountName: "",
    adCampaignName: "",
    adGroupName: "",
    reviewStatus: 0,
    reviewReason: 0,
    reviewStatusForView: 0,
  });

  // クリエイティブ登録・編集
  const [titleIndexes, setTitleIndexes] = useState([1]);
  const [descriptionIndexes, setDescriptionIndexes] = useState([1]);
  const [imageIndexes, setImageIndexes] = useState([1]);
  const [tagIndexes, setTagIndexes] = useState([1]);
  // const [movieIndexes, setMovieIndexes] = useState([1]);

  /**
   * クリエイティブの入力フォームのindexを増やす。
   * @param {number} indexType - クリエイティブタイプ 1:見出し, 2:説明文, 3:画像, 4:動画
   */
  function addIndexes(indexType: number) {
      switch (indexType){
      case 1: // 見出し
          // @ts-ignore
          setTitleIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
          break;
      case 2: // 説明文
          // @ts-ignore
          setDescriptionIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
          break;
      case 3: // 画像
          // @ts-ignore
          setImageIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
          break;
      case 4: // 動画
          // // @ts-ignore
          // setMovieIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
          break;
      default:
      }
  }


  /**
   * 編集時 クリエイティブの入力フォームをセットする
   * @param {number} arrayLength - クリエイティブのAPIレスポンスの配列の長さ
   * @param {number} indexType - クリエイティブタイプ 1:見出し, 2:説明文, 3:画像, 4:動画
   */
  function setInputForm(arrayLength: number, indexType: number) {
    switch (indexType){
    case 1: // 見出し
        for (let i = 0; i < arrayLength; i++) {
            addIndexes(1);
        }
        setTitleIndexes(current => [...current.filter(i => i !== 1)]);
        break;
    case 2: // 説明文
        for (let i = 0; i < arrayLength; i++) {
            addIndexes(2);
        }
        setDescriptionIndexes(current => [...current.filter(i => i !== 1)]);
        break;
    case 3: // 画像
        for (let i = 0; i < arrayLength; i++) {
            addIndexes(3);
        }
        setImageIndexes(current => [...current.filter(i => i !== 1)]);
        break;
    case 4: // 動画
        // for (let i = 0; i < arrayLength; i++) {
        //     addIndexes(4);
        // }
        // setMovieIndexes(current => [...current.filter(i => i !== 1)]);
        break;
    default:
    }
  }

  const checkTitle = (index: number) => {
    if (titles[index].text === "") {
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open: true,
                type: "error",
                message: "見出しを入力してください。"
        }});
        return true;
    }

    const errorMessage = getSubjectStrCheckErrorMsg(titles[index].text);
    if (errorMessage) {
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open: true,
                type: "error",
                message: "見出しに禁止文字が入力されています。"
        }});
        return true;
    }

    let isSame = false;

    let titleTextCount = 0;
    let title1 : string = "";
    let title2 : string = "";
    titles.forEach(function(v: AdTitle) {
        if(title1 == v.text || title2 == v.text){
            isSame = true;
        }
        if(titleTextCount == 0) {
          title1 = v.text;
        }
        if(titleTextCount == 1) {
          title2 = v.text;
        }
        titleTextCount++;
    });

    if (isSame) {
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open: true,
                type: "error",
                message: "見出しが重複しています。"
        }});
        return true;
    }

    return false;
  }

  const addTitle = async (index: number) => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}/${advertisementId}/add-title`;

    var request: AdTitle = {
        text: titles[index].text,
    };

    try {
      await ApolloAxios.post(
          url,
          request,
          {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${state.accesstoken}`,
              }
          }
      );
      return false;
    } catch (error) {
        setmsg({
            type: "setMessage",
            payload: {
                ...data,
                open: true,
                type: "error",
                message: "見出しの追加に失敗しました"
            }
        });
        return true;
    }
  };

  const checkDescription = (index: number) => {
    if (descriptions[index].text === "") {
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open: true,
                type: "error",
                message: "説明文を入力してください。"
        }});
        return true;
    }

    const errorMessage = getTextStrCheckErrorMsg(descriptions[index].text);
    if (errorMessage) {
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open: true,
                type: "error",
                message: "説明文に禁止文字が入力されています。"
        }});
        return true;
    }

    let isSame = false;

    let descriptionTextCount = 0;
    let description1 : string = "";
    let description2 : string = "";
    descriptions.forEach(function(v: AdDescription) {
        if(description1 == v.text || description2 == v.text){
            isSame = true;
        }
        if(descriptionTextCount == 0) {
            description1 = v.text;
        }
        if(descriptionTextCount == 1) {
            description2 = v.text;
        }
        descriptionTextCount++;
    });

    if (isSame) {
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open: true,
                type: "error",
                message: "説明文が重複しています。"
        }});
        return true;
    }
    return false;
  }
 
  const addDescription = async (index: number) => { 
    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}/${advertisementId}/add-description`;

    var request: AdDescription = {
        text: descriptions[index].text,
    };

    try {
        await ApolloAxios.post(
            url,
            request,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.accesstoken}`,
                }
            }
        );
        return false;
    } catch (error) {
        setmsg({
            type: "setMessage",
            payload: {
                ...data,
                open: true,
                type: "error",
                message: "説明文の追加に失敗しました"
            }
        });
        return true;
    }
  };

  const checkImage = (index: number) => {
    let listImages: AdImage[] = [];
    let isError1 = false;

    // 重複チェック(一意のリストを用意し、リストの要素数が一致するかでチェック)
    const uniqueSelectedFileOrigins: string[] = Array.from(new Set(selectedFileOrigins));
    if(uniqueSelectedFileOrigins.length != selectedFileOrigins.length) {
      isError1 = true;
    }

    if (isError1) {
      setmsg ({
        type: "setMessage",
        payload: {
            ...data,
            open: true,
            type: "error",
            message: "画像が重複しています。"
      }});
      return true;
    }

    isError1 = false;

    if(ZEUS_PMP_TYPE.PLACEMENT_DESIGNATION == pmpType || ZEUS_PMP_TYPE.PREMIUM_PLACEMENT_DESIGNATION == pmpType) {
      let imageSizeTypeList: number[] = [];

      selectedFileOrigins.forEach(function(textImage: string){
        let r1 = textImage.split(" ");

        let w1 = r1[1].replace("(幅", "").replace(",", "");
        let width = parseInt(w1);

        let h1 = r1[2].replace("高さ", "").replace(")", "");
        let height = parseInt(h1);

        let imageSizeType = getImageSizeType(width, height);
        imageSizeTypeList.push(imageSizeType);

        let id1 = r1[0].replace("img", "");
        let id2 = parseInt(id1);
        listImages.push({adAccountImageResourceId: id2});
      })

      // 重複チェック(一意のリストを用意し、リストの要素数が一致するかでチェック)
      const uniqueImageSizeTypeList: number[] = Array.from(new Set(imageSizeTypeList));
      if(uniqueImageSizeTypeList.length != imageSizeTypeList.length) {
        isError1 = true;
      }

    } else {
      let aspectCount1_1 = 0;
      let aspectCount1_9 = 0;
      selectedFileOrigins.forEach(function(textImage: string){
        let r1 = textImage.split(" ");

        let w1 = r1[1].replace("(幅", "").replace(",", "");
        let width = parseInt(w1);

        let h1 = r1[2].replace("高さ", "").replace(")", "");
        let height = parseInt(h1);
        let aspect =  Math.round(width * 10 / height) / 10;

        if (aspect === 1) {
          aspectCount1_1++;
        } else if(aspect === 1.9) {
          aspectCount1_9++;
        }
          
        if (aspectCount1_1 >= 2 || aspectCount1_9 >= 2) {
          isError1 = true;
        }

        let id1 = r1[0].replace("img", "");
        let id2 = parseInt(id1);
        listImages.push({adAccountImageResourceId: id2});
      })
    }

    if (isError1) {
        setmsg ({
          type: "setMessage",
          payload: {
              ...data,
              open:true,
              type:"error",
              message:"同じ縦横比の画像は1広告1枚まで選択可能です。"
        }});
        return true;
    }
    return false;
  }

  const addImage = async (index: number) => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}/${advertisementId}/add-image`;

    var r1 = selectedFileOrigins[index].split(" ");
    var r2 = r1[0].replace("img", "");
    let id = parseInt(r2);

    var request: AdImage = {
        adAccountImageResourceId: id,
    };

    try {
      await ApolloAxios.post(
          url,
          request,
          {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${state.accesstoken}`,
              }
          }
      );
      return false;
    } catch (error) {
      setmsg({
          type: "setMessage",
          payload: {
              ...data,
              open: true,
              type: "error",
              message: "画像の追加に失敗しました"
          }
      });
      return true;
    }
};

  useEffect(() => {
    ApolloAxios.get(`${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}/${advertisementId}`).then(response => {
      if (response.status !== 200) {
        const res = response.data;
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : "広告情報の取得に失敗しました",
        });
      }
      const resultData = response.data;
      const newAdvertisement: AdvertisementZeus = {
        id: resultData.id ? resultData.id : 0,
        createdAt: resultData.createdAt ? resultData.createdAt : "",
        updatedAt: resultData.updatedAt ? resultData.updatedAt : "",
        lastUpdateUserId: resultData.lastUpdateUserId ? resultData.lastUpdateUserId : "",
        adGroupId: resultData.adGroupId ? resultData.adGroupId : 0,
        adGroupName: resultData.adGroupName ? resultData.adGroupName : "",
        adCampaignId: resultData.adCampaignId ? resultData.adCampaignId : 0,
        adCampaignName: resultData.adCampaignName ? resultData.adCampaignName : "",
        link: resultData.link ? resultData.link : "",
        name: resultData.name ? resultData.name : "",
        adType: resultData.adType ? resultData.adType : 0,
        status: resultData.status ? resultData.status : 1,
        customUrl: resultData.customUrl ? resultData.customUrl : "",
        sponsor: resultData.sponsor ? resultData.sponsor : "",
        cta: resultData.cta ? resultData.cta : null,
        sponsorDomain: resultData.sponsorDomain ?? "",
        titles: resultData.titles ? resultData.titles : [],
        descriptions: resultData.descriptions ? resultData.descriptions : [],
        images: resultData.images ? resultData.images : [],
        videos: [],
        apps: [],
        mails: [],
        tags: resultData.tags ? resultData.tags : [],
        adAccountId: resultData.adAccountId ? resultData.adAccountId : 0,
        adAccountName: "",
        reviewStatus: resultData.reviewStatus ? resultData.reviewStatus :0,
        reviewReason: resultData.reviewReason ? resultData.reviewReason :0,
        reviewStatusForView: resultData.reviewStatusForView ? resultData.reviewStatusForView : 0,
      }
      let resTitles = response.data.titles;
      let resDescriptions = response.data.descriptions;
      let resImages = response.data.images;
      let resTags = response.data.tags;
      // let resVideos = response.data.videos;

      if (typeof resTitles !== 'undefined' && resTitles !== null) {
          setTitles(response.data.titles);
          setTitleCount(response.data.titles.length);
          setInputForm(response.data.titles.length, 1);
      }
      if (typeof resDescriptions !== 'undefined' && resDescriptions !== null) {
          setDescriptions(response.data.descriptions);
          setDescriptionCount(response.data.descriptions.length);
          setInputForm(response.data.descriptions.length, 2);
      }
      if (typeof resImages !== 'undefined' && resImages !== null) {
          setImages(response.data.images);
          setImageCount(response.data.images.length);
          setInputForm(response.data.images.length, 3);
      }
      if (typeof resTags !== 'undefined' && resTags !== null) {
        setTags(response.data.tags);
    }


      setAdvertisement(newAdvertisement);
      setTitles(newAdvertisement.titles);
      setDescriptions(newAdvertisement.descriptions);
      setImages(newAdvertisement.images);
      setTags(newAdvertisement.tags)

      beforeEditRecord.current = {
        adAccountId: platformAccountId,
        adGroupId: newAdvertisement.adGroupId,
        adGroupName: newAdvertisement.adGroupName,
        campaignId: newAdvertisement.adCampaignId,
        campaignName: newAdvertisement.adCampaignName,
        customUrl: newAdvertisement.customUrl,
        sponsor: newAdvertisement.sponsor,
        cta: newAdvertisement.cta,
        sponsorDomain: newAdvertisement.sponsorDomain,
        link: newAdvertisement.link,
        name: newAdvertisement.name,
        status: newAdvertisement.status,
        images: newAdvertisement.images.map((value: AdImage) => value.adAccountImageResourceId),
        tags: newAdvertisement.tags.map((value: AdTag) => value.adAccountTagResourceId),
        titles: newAdvertisement.titles?.length == 1 ? "[" + newAdvertisement.titles[0].text  + "]" : newAdvertisement.titles?.length == 1 ? "" : "[" + newAdvertisement.titles.filter((output: AdTitle) => {
          return output.text !== "" }).map((output: AdTitle) => {
            return output.text; }).join("、") + "]",
        descriptions: newAdvertisement.descriptions?.length == 1 ? "[" + newAdvertisement.descriptions[0].text  + "]" : newAdvertisement.descriptions?.length == 1 ? "" : "[" + newAdvertisement.descriptions.filter((output: AdDescription) => {
          return output.text !== "" }).map((output: AdDescription) => {
            return output.text; }).join("、") + "]",
      }
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });
  }, []);

  const handleSubmit = async (
  ) => {
    let isSuccess = false;

    const body = {
      link: advertisement.link,
      name: advertisement.name,
      status: advertisement.status,
    }


    // クリエイティブ情報の入力チェック処理
    let hasValidationError = false;
    if(titleCount !== 0 && titleCount < titleIndexes.length){
      for(let i = titleCount; i < titleIndexes.length; i++) {
        if(hasValidationError === false) {
          hasValidationError = checkTitle(i);
        }
      }
    }

    if(hasValidationError === false && descriptionCount !== 0 && descriptionCount < descriptionIndexes.length){
      for(let i = descriptionCount; i < descriptionIndexes.length; i++) {
        if(hasValidationError === false) {
          hasValidationError = checkDescription(i);
        }
      }
    }

    if(hasValidationError === false && imageCount < imageIndexes.length){
      for(let i = imageCount; i < imageIndexes.length; i++) {
        if(hasValidationError === false) {
          hasValidationError = checkImage(i);
        }
      }
    }

    // クリエイティブ情報の入力チェックに問題が無ければ、追加処理
    let addResultHasError = false;
    if(hasValidationError === false){
      if(titleCount !== 0 && titleCount < titleIndexes.length){
        for(let i = titleCount; i < titleIndexes.length; i++) {
          if(addResultHasError === false) {
            addResultHasError = await addTitle(i);
          }
        }
      }

      if(addResultHasError === false && descriptionCount !== 0 && descriptionCount < descriptionIndexes.length){
        for(let i = descriptionCount; i < descriptionIndexes.length; i++) {
          if(addResultHasError === false) {
            addResultHasError = await addDescription(i);
          }
        }
      }

      if(addResultHasError === false && imageCount < imageIndexes.length){
        for(let i = imageCount; i < imageIndexes.length; i++) {
          if(addResultHasError === false) {
            addResultHasError = await addImage(i);
          }
        }
      }
    }

    const executeLog = createUserLog(
      state,
      "パフォーマンス広告",
      "広告",
      "更新",
      "広告（パフォーマンス広告）編集",
      beforeEditRecord.current,
      {
        adAccountId: platformAccountId,
        adGroupId: advertisement.adGroupId,
        adGroupName: advertisement.adGroupName,
        campaignId: advertisement.adCampaignId,
        campaignName: advertisement.adCampaignName,
        customUrl: advertisement.customUrl,
        sponsor: advertisement.sponsor,
        cta: advertisement.cta,
        sponsorDomain: advertisement.sponsorDomain,
        link: advertisement.link,
        name: advertisement.name,
        status: advertisement.status,
        images: images.map((value: AdImage) => value.adAccountImageResourceId),
        titles: titles?.length == 1 ? "[" + titles[0].text  + "]" : titles?.length == 1 ? "" : "[" + titles.filter((output: AdTitle) => {
          return output.text !== "" }).map((output: AdTitle) => {
            return output.text; }).join("、") + "]",
        descriptions: descriptions?.length == 1 ? "[" + descriptions[0].text  + "]" : descriptions?.length == 1 ? "" : "[" + descriptions.filter((output: AdDescription) => {
          return output.text !== "" }).map((output: AdDescription) => {
            return output.text; }).join("、") + "]",
        tags: tags.map((value: AdTag) => value.adAccountTagResourceId),
      },
      advertisement.adCampaignId.toString(), // キャンペーンID
      advertisement.adCampaignName, // キャンペーン名
      advertisement.adGroupId.toString(), // 広告グループID
      advertisement.adGroupName, // 広告グループ名
    );
    executeLog.targetID = String(advertisementId);
    executeLog.targetName = beforeEditRecord.current?.name? beforeEditRecord.current.name: "";
    ApolloEventRecord({...executeLog, logType: "execute"});


    if (hasValidationError === false &&  addResultHasError === false) {
        const adsUpdateRequest: AdUpdate = {
          name: advertisement.name,
          status: advertisement.status,
          link: advertisement.link,
          customUrl: advertisement.customUrl,
          sponsor: advertisement.sponsor,
          cta: advertisement.cta,
          sponsorDomain: advertisement.sponsorDomain,
        };

        await ApolloAxios.patch(`${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}/${advertisementId}`, adsUpdateRequest).then(response => {
          const res: ApiResponse = response.data;
          if (!isSuccessApi(res.resultCode)) {
            const res = response.data;
            return Promise.reject({
              open: true,
              type: getResultType(res.resultCode),
              errmsg: res?.message ? res.message : "広告の更新に失敗しました",
            });
          }

          isSuccess = true;
          advertisementData.current = res.result;
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: getResultType(res.resultCode),
              message: "広告を更新しました",
            }
          });

        }).catch(err => {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: err.type,
              message: err.errmsg,
            }
          });
        }).finally(() => {
          const resultLog: LogData = {
            ...executeLog,
            eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
            targetID: advertisementData.current? advertisementData.current?.id.toString(): "",
            targetName: advertisementData.current? advertisementData.current?.name: "",
            result: isSuccess ? "成功" : "失敗",
          };
          ApolloEventRecord({...resultLog, logType: "result"});
          if(isSuccess) listReloadFunc && listReloadFunc();
        });
    }
  };

  const handleGoBack = () => {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    });
  }

  return (
    <AdvertisementFormZeus
      platformAccountId={platformAccountId}
      advertisementId={advertisementId}
      advertisementState={{
        advertisement: advertisement,
        setAdvertisement: setAdvertisement,
        deliveryType: deliveryType,
        setDeliveryType: setDeliveryType,
        pmpType: pmpType,
        setPmpType: setPmpType,
        placementSettingId: placementSettingId,
        setPlacementSettingId: setPlacementSettingId,
      }}
      adResourceState= {{
        titles: titles,
        setTitles: setTitles,
        titleIndexes: titleIndexes,
        setTitleIndexes: setTitleIndexes,
        isAddedTitle: isAddedTitle,
        setIsAddedTitle: setIsAddedTitle,
        descriptions: descriptions,
        setDescriptions: setDescriptions,
        descriptionIndexes: descriptionIndexes,
        setDescriptionIndexes: setDescriptionIndexes,
        isAddedDescription: isAddedDescription,
        setIsAddedDescription: setIsAddedDescription,
        images: images,
        setImages: setImages,
        imageIndexes: imageIndexes,
        setImageIndexes: setImageIndexes,
        isAddedImage: isAddedImage,
        setIsAddedImage: setIsAddedImage,
        selectedFileOrigins: selectedFileOrigins,
        setSelectedFileOrigins: setSelectedFileOrigins,
        tags: tags,
        setTags: setTags,
        tagIndexes: tagIndexes,
        setTagIndexes: setTagIndexes,
        isAddedTag: isAddedTag,
        setIsAddedTag: setIsAddedTag,
      }}
      submitAction={handleSubmit}
      goBackAction={handleGoBack}
    />
  )
};

const createUserLog = (
  apolloContex: any,
  menu: string,
  category: string,
  actionType: string,
  displayName: string,
  beforeInfo: LogRecord | null,
  afterInfo: LogRecord,
  campaignId?: string,
  campaignName?: string,
  adGroupId?: string,
  adGroupName?: string,
) => {
  const items: ItemList[] = [
    createUserLogItemListFromString("広告名", "name", beforeInfo, afterInfo),
    createUserLogItemListByOption("ステータス", "status", beforeInfo, afterInfo, options_state_edit),
    createUserLogItemListFromArrayAddSB("広告アセット画像", "images", beforeInfo, afterInfo),
    createUserLogItemListFromString("見出し", "titles", beforeInfo, afterInfo),
    createUserLogItemListFromString("説明文", "descriptions", beforeInfo, afterInfo),
    createUserLogItemListFromString("情報提供者名", "sponsor", beforeInfo, afterInfo),
    createUserLogItemListFromString("最終リンク先URL ", "link", beforeInfo, afterInfo),
    createUserLogItemListFromString("情報提供者ドメイン ", "sponsorDomain", beforeInfo, afterInfo),
  ];

  const retObj = createLogDate(
    apolloContex,
    menu,
    category,
    actionType,
    displayName,
    items,
    campaignId,
    campaignName,
    adGroupId,
    adGroupName,
  );

  return retObj
}

export default AdvertisementEditZeus;
